<template>
  <v-container>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="8"
      >
        <v-card flat>
          <v-card-title>За контакт с Артикет ЕООД:</v-card-title>
          <v-card-text>
            <p>email: info@articket.eu</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'contacts',
}
</script>

<style scoped></style>
